import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import PageHeader from "../components/layout/PageHeader";
import BlogCard from "../components/features/BlogCard";
import { api } from "../lib/api";
import { setPageMeta, JsonLd, breadcrumbSchema } from "../lib/schema";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPageMeta({
      title: "UK to Nigeria Shopping Guide & Tips | MPS Blog",
      description:
        "Practical guides, brand spotlights, and pricing breakdowns for shopping from the UK and shipping to Nigeria. From the MPS concierge team.",
      canonical: "https://privateshopper.co.uk/blog",
    });
    api
      .getBlogPosts()
      .then(setPosts)
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <JsonLd data={breadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Blog" },
      ])} />
      <PageHeader
        overline="Journal"
        title={<>Guides for shopping the <span className="italic text-[#C9A96E]">UK from Nigeria</span>.</>}
        body="Practical, opinionated writing from the MPS concierge team. New articles every fortnight."
      />

      <section className="container-mps py-20 md:py-28">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="bg-[#E5E0D8]/30 h-[460px] animate-pulse" />
            ))}
          </div>
        ) : posts.length === 0 ? (
          <div className="text-center py-24">
            <p className="text-[#6B7280]">No posts yet. Check back soon.</p>
          </div>
        ) : (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {posts.map((p) => (
              <motion.div
                key={p.slug}
                variants={{
                  hidden: { opacity: 0, y: 24 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
                }}
              >
                <BlogCard post={p} />
              </motion.div>
            ))}
          </motion.div>
        )}
      </section>
    </>
  );
}
